var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eb-dashboard"},[_c('headerGeneral'),_c('sideMenu'),_c('main',{staticClass:"eb-main",attrs:{"role":"main"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }